/* eslint-disable promise/param-names */
const state = {
  menu:{
      book: ''
  }
}

const getters = {
  menu: state => state.menu,
}

const mutations = {
    changeMenu(state, payload){
        state.menu = payload;
    }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js